import {
  base_colorContentBorderSecondary,
  tag_colorTagNewText,
} from 'ext-ui/style/colors'
import { spacing } from 'ext-ui/style/spacing'
import React from 'react'
import ReceiptAgentExtendLogo from 'src/assets/svgs/ReceiptAgentExtendLogo.svg'
import ReceiptAgentSparkle from 'src/assets/svgs/ReceiptAgentSparkle.svg'
import { css } from 'styled-components'

interface ReceiptAgentAvatarProps {
  className?: string
  testId?: string
}

const style = css`
  position: relative;
  display: inline-flex;
  flex: none;
  align-items: center;
  justify-content: center;
  width: ${spacing(6)};
  height: ${spacing(6)};
  border-radius: 50%;
  background: #1e2c4c;

  > img {
    width: ${spacing(3)};
    height: ${spacing(3)};
  }

  > span {
    position: absolute;
    top: 15.33px;
    left: 15.33px;
    display: inline-flex;
    align-items: center;
    justify-content: center;
    width: 10.08px;
    height: 10.08px;
    box-sizing: content-box;
    border: 1.2px solid ${base_colorContentBorderSecondary};
    border-radius: 50%;
    background: ${tag_colorTagNewText};
    overflow: hidden;
  }

  > span > span {
    position: absolute;
    top: 1.01px;
    left: 1.01px;
    display: grid;
    width: 8.064px;
    height: 8.064px;
    box-sizing: border-box;
    place-items: center;
    padding: 8.33%;
    overflow: hidden;
  }

  > span > span img {
    display: block;
    width: 100%;
    height: 100%;
  }
`

const ReceiptAgentAvatar = ({
  className,
  testId = 'receipt-agent-avatar',
}: ReceiptAgentAvatarProps): React.ReactElement => {
  const avatarClassName = className ?? 'ReceiptAgentAvatar'

  return (
    <span
      css={style}
      className={avatarClassName}
      data-testid={testId}
      aria-hidden
    >
      <img
        className={`${avatarClassName}-logo`}
        src={ReceiptAgentExtendLogo}
        alt={''}
      />
      <span className={`${avatarClassName}-sparkle`}>
        <span className={`${avatarClassName}-sparkle-artwork`}>
          <img src={ReceiptAgentSparkle} alt={''} />
        </span>
      </span>
    </span>
  )
}

export default ReceiptAgentAvatar
